import {AiChatOpenEditorType, GA4EventName, GA4EventParamName} from '@Libraries/ga-events';

interface UseOpenChatImageInEditor {
  openPosterInEditor: (hashedId: string) => void;
}

export const useOpenChatImageInEditor = (): UseOpenChatImageInEditor => {
  const openPosterInEditor = (hashedId: string): void => {
    window.open(window.PMW.util.site_url(`posterbuilder/loadFromAiChatImage/${hashedId}`), '_blank');
    window.PMW.gtm.trackGA4CustomEvent(GA4EventName.AICHAT_OPEN_EDITOR, {[GA4EventParamName.TYPE]: AiChatOpenEditorType.EDIT_AS_IMAGE});
  };

  return {openPosterInEditor};
};
